export default __webpack_public_path__ + "static/media/1676.6731ad80.png";